import { Component, inject, DestroyRef } from '@angular/core';
import { ElectronService } from '@core/platform/electron.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@env';
import { AuthService } from '@core/auth/auth.service';
import { SidebarLogoComponent } from './sidebar-logo/sidebar-logo.component';
import { SidebarMenuComponent } from './sidebar-menu/sidebar-menu.component';
import { SidebarSettingsComponent } from './sidebar-settings/sidebar-settings.component';

import { SvgIconComponent } from 'angular-svg-icon';
import { InputCheckboxSwitchComponent } from 'pi-ui';
import { FormsModule } from '@angular/forms';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';
import { takeUntilDestroyedSafe } from '@core/helpers/take-until-destroyed-safe';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    imports: [SidebarLogoComponent, SidebarMenuComponent, SidebarSettingsComponent, SvgIconComponent, InputCheckboxSwitchComponent, FormsModule, TooltipDirective]
})
export class SidebarComponent {
  private readonly destroyRef = inject(DestroyRef);

  private readonly electronService = inject(ElectronService);
  readonly translate = inject(TranslateService);
  private readonly authService = inject(AuthService);

  electron = environment.electron;
  #active = false;

  get isActive() {
    return this.#active;
  }

  set isActive(v: boolean) {
    if (this.authService.currentUserId && this.authService.mainAccountId) {
      this.electronService.setIsEnabled(this.authService.currentUserId, this.authService.mainAccountId, v);
    }
  }

  constructor() {
    if (this.electron) {
      this.electronService.enabled$.pipe(takeUntilDestroyedSafe(this.destroyRef)).subscribe((value) => {
        this.#active = value;
      });
    }
  }
}
